const translations = {
    unsubscribe: {
        header: "Manage my notifications",
        saveChanges: "Save my preferences",
        glitter: {
            newRequest: "New request",
            newAppointment: "New appointment",
            appointmentApproaching: "Upcoming appointment",
            appointmentCanceled: "Appointment canceled",
            payoutInProcess: "Payout in process",
        },
        renter: {
            glitterFound: "Glitter found",
            glitterApproaching: "Glitter approaching",
            glitterWriting: "Glitter writing report",
            requestCanceled: "Request canceled",
            reportReceived: "Report received",
        },
        customer: "Customer",
        confirmationMessage: "Your preferences have been saved successfully.",
    },
    home: {
        nav: {
            home: "Home",
            download: "Download",
            about: "About",
            faq: "FAQ",
            contact: "Contact",
        },
        hero: {
            content: "New-generation cleaning. Fast. Efficient. Effortless !",
            callToAction: "Install the app now!",
        },
        download: {
            title: "Download the app now!",
            desc: "Get the app on your device and start using it today.",
            appleDownload: "Download on the App Store",
            androidDownload: "Get it on Google Play",
        },
        about: {
            title1: "Let us take care of your vehicle",
            desc1: "GlitGo is a platform that connects users with certified vehicle cleaning and inspection professionals. Our goal is to ensure that your vehicle is in perfect condition.",
            btn1: "Start now",
            title2: "Become a Glitter",
            desc2: "You can also become a Glitter and offer your services to users. Join our platform and start earning money by providing quality services.",
            btn2: "Learn more",
        },
        faq: {
            title: "Frequently Asked Questions",
            questions: [
                {
                    question: "What is GlitGo?",
                    answer: "GlitGo is a platform that allows you to request services such as vehicle cleaning or inspection directly from your phone. Certified professionals come to your vehicle's location at the time you choose to provide the service.",
                },
                {
                    question: "How does GlitGo work?",
                    answer: "GlitGo allows you to schedule vehicle cleaning or inspection services from your phone. Certified professionals arrive at the location and time you select to perform the service.",
                },
                {
                    question: "Is GlitGo available in my city?",
                    answer: "GlitGo is being rolled out in multiple cities. Please check availability on our app or website to see if we operate in your area.",
                },
                {
                    question: "How can I become a Glitter?",
                    answer: "To become a Glitter, you can sign up on our platform. Once registered, you will have access to the necessary tools to start offering your services.",
                },
                {
                    question: "What are the benefits of using GlitGo?",
                    answer: "Using GlitGo ensures that your vehicle remains in good condition through certified cleanings or inspections, while also simplifying the scheduling and tracking of services.",
                },
                {
                    question: "How can I contact GlitGo?",
                    answer: "You can contact GlitGo via the contact section on our website or app, or by sending an email to our customer support at support@glitgo.com.",
                },
            ],
        },

        contact: {
            title: "Contact Us",
            invitation: "Do you have any questions or suggestions? Contact us!",
        },
    },
    footer: {
        termsOfUse: "Terms of Use",
        termsOfSale: "General Terms of Sale",
        privacyPolicy: "Privacy Policy",
        cookiesPolicy: "Cookies Policy",
        copyright: "All rights reserved.",
    },
    emailConfirmed: {
        header: "Email confirmed",
        desc: "Your email has been confirmed successfully. You can now go back to the app and log in.",
        gotoApp: "Please return to the mobile application to continue.",
    },
    forgotPassword: {
        header: "Forgot password",
        email: {
            label: "Email address",
            errorMessage: "Please enter your email address",
            validEmailRequired: "Please enter a valid email address",
            placeholder: "Enter your email address",
        },
        submit: "Submit",
        success: "Success",
        successDesc:
            "A password reset link has been sent to your email. Please check your inbox and follow the instructions.",
        error: "Error",
        submitting: "Submitting...",
        errors: {
            tryAgainLater:
                "An unexpected error occurred. Please try again later.",
            resetLinkNotSent: "An error occurred while sending the reset link.",
        },
    },

    notFound: {
        message: "Oops! The page you are looking for does not exist.",
        goHome: "Go back home",
    },

    resetPassword: {
        header: "Reset Password",
        newPassword: {
            label: "New Password",
            placeholder: "Enter your new password",
            emptyError: "Please input your new password!",
            tooShortError: "Password must be at least 8 characters long.",
        },
        confirmPassword: {
            label: "Confirm New Password",
            placeholder: "Confirm your new password",
            emptyError: "Please confirm your new password!",
            noMatchError: "The two passwords do not match!",
        },
        submitting: "Submitting...",
        submit: "Submit",
    },

    chekerVerif: {
        text: "Redirecting in progress, please wait...",
        invalidID: "Invalid ID.",
        failedRedirect: "Failed to redirect. Please try again later.",
        errorOccurred:
            "An error occurred while retrieving the redirection link.",
        noRedirect: "No redirection link available.",
    },

    chekerVerificationFinished: {
        title: "Your updates have been successfully submitted!",
        subTitle:
            "Your submission is under verification. Please return to the mobile application to continue.",
    },

    ToU: {
        header: "Terms of Use (ToU)",
        content: [
            {
                label: "1. Acceptance of the Terms",
                desc: "The use of the GlitGo application ('Application') is subject to these Terms of Use ('ToU'). By using the Application, you accept these ToU in their entirety. If you do not accept these terms, please do not use the Application.",
            },
            {
                label: "2. Description of the Service",
                desc: "GlitGo allows users to request services related to vehicle inspection and maintenance through the Application. The services are provided by partner service providers ('Providers') registered on the platform.",
            },
            {
                label: "3. Registration and Account",
                desc: "To use the services of the Application, you must create an account by providing accurate and complete personal information. You are responsible for the confidentiality of your credentials and for all activities conducted on your account.",
            },
            {
                label: "4. User Obligations",
                desc: "Users must:\n- Provide accurate information when requesting services.\n- Respect appointments and conditions established with the Providers.\n- Not use the Application for illegal or prohibited purposes.",
            },
            {
                label: "5. Liability",
                desc: "The GlitGo application acts solely as an intermediary between users and Providers. We do not guarantee the quality of services provided by Providers and are not responsible for disputes between users and Providers.",
            },
            {
                label: "6. Privacy",
                desc: "Your personal data is collected and processed in accordance with our Privacy Policy. We are committed to protecting your information and not disclosing it to third parties without your consent, unless required by law.",
            },
            {
                label: "7. Intellectual Property",
                desc: "All intellectual property rights related to the Application and its content are the exclusive property of GlitGo or its licensors. You are not authorized to use these elements without prior permission.",
            },
            {
                label: "8. Changes to the ToU",
                desc: "GlitGo reserves the right to modify these ToU at any time. The changes will be posted on the Application and will take effect upon their online publication. Your continued use of the Application constitutes acceptance of the changes.",
            },
            {
                label: "9. Termination",
                desc: "GlitGo reserves the right to suspend or terminate your account if you violate the ToU or misuse the Application.",
            },
            {
                label: "10. Governing Law and Jurisdiction",
                desc: "These ToU are governed by French law. Any dispute related to the Application will be subject to the exclusive jurisdiction of the French courts.",
            },
        ],
    },
    GTS: {
        header: "General Terms of Sale (GTS)",
        content: [
            {
                label: "1. Scope",
                desc: "These General Terms of Sale ('GTS') apply to all service requests made via the GlitGo application ('Application') and provided by Providers registered on the platform.",
            },
            {
                label: "2. Order and Confirmation",
                desc: "The order for services is placed through the Application. Once the request is confirmed, a service contract is established between the user ('Client') and the Provider. GlitGo is not a party to the service contract and acts solely as an intermediary.",
            },
            {
                label: "3. Prices and Payment",
                desc: "The service prices are indicated on the Application. Payments are made directly to the Provider, unless otherwise specified. GlitGo may receive a commission on transactions conducted through the Application.",
            },
            {
                label: "4. Cancellation and Refund",
                desc: "The cancellation and refund conditions are defined by the Provider. Cancellation or refund requests must be addressed directly to the Provider, with GlitGo not being responsible for these aspects.",
            },
            {
                label: "5. Service Execution",
                desc: "Providers are responsible for the execution of services in accordance with the conditions specified in the Client's request. GlitGo does not guarantee the quality of the services and assumes no responsibility in case of non-compliance or dispute.",
            },
            {
                label: "6. Claims",
                desc: "Any claim related to the service must be addressed directly to the Provider. GlitGo does not intervene in the resolution of disputes between the Client and the Provider.",
            },
            {
                label: "7. Privacy",
                desc: "The personal information collected during the order is processed in accordance with our Privacy Policy. GlitGo is committed to protecting personal data and not disclosing it without consent, except as required by law.",
            },
            {
                label: "8. Changes to the GTS",
                desc: "GlitGo reserves the right to modify the GTS at any time. The changes will be posted on the Application and will take effect upon their online publication. Your continued use of the Application after modification constitutes acceptance of the new GTS.",
            },
            {
                label: "9. Governing Law and Jurisdiction",
                desc: "These GTS are governed by French law. Any dispute related to the service provision will be subject to the exclusive jurisdiction of the French courts.",
            },
        ],
    },

    privacyPolicy: {
        header: "Privacy Policy",
        description:
            "Welcome to GlitGo. Protecting your privacy is a priority for us. This privacy policy explains what information we collect, how we use it, and the options you have to manage your data.\n\nLast updated: December 6, 2025",
        content: [
            {
                label: "1. Information Collected",
                desc: "We collect several types of data when you use our services:",
            },
            {
                label: "1.1. Information provided by the user",
                desc: "- First name, last name\n- Email address\n- Phone number\n- Postal address\n- Payment information (via secure providers like Stripe)\n- Identity and compliance documents required for Glitters (ID card or passport, proof of incorporation, VAT/Tax IDs, SSN last 4 digits when Stripe requires it)\n- Bank details so we can route payouts (IBAN, routing number, last digits of the account number)\n- Information about the vehicle(s) to be inspected or cleaned:\n\t- Make, model, year\n\t- License plate\n\t- Location\n\t- Photos\n\t- Other specific details",
            },
            {
                label: "1.2. Automatically collected technical data",
                desc: "- IP address and the city/region inferred from it\n- Device model, operating system version, browser language, timezone and app version\n- Usage events, diagnostics, crash/error logs and request identifiers recorded by our Strapi backend\n- Push-notification tokens and device identifiers generated by Apple, Google or Expo so we can deliver alerts",
            },
            {
                label: "1.3. Location and scheduling data",
                desc: "- Service addresses including street, access notes, latitude/longitude coordinates and preferred time slots\n- Geocoding queries typed inside the apps (relayed to the Google Places API to suggest accurate addresses)\n- Working radius, bounding boxes and availability schedules saved for Glitters",
            },
            {
                label: "1.4. Locally stored data",
                desc: "GlitGo uses Async Storage to store certain data locally on your device, such as your active session, refresh token, push token, pending requests and offline report drafts (including cached photos) so that you can finish a report without network access. You can erase these data by logging out, clearing the app cache or uninstalling the app.",
            },
            {
                label: "1.5. Verification and payout documents",
                desc: "- Identity and compliance documents submitted through Stripe Connect (we store masked references while Stripe stores the files)\n- Tax identifiers and company registration data required by regulations\n- Bank account information (IBAN, BIC, routing numbers, last digits) used to send payouts. We only keep the minimum amount of information required for support; the full number stays with Stripe.",
            },
            {
                label: "1.6. Device identifiers and notifications",
                desc: "- Expo, Apple Push Notification service and Firebase Cloud Messaging tokens linked to your account so we can deliver urgent alerts and reminders\n- Device OS, preferred language and timezone to personalize notifications and debug issues more efficiently",
            },
            {
                label: "1.7. Third-party data",
                desc: "We may receive information about you from our payment partners (e.g., Stripe compliance decisions and payout statuses), push providers (delivery receipts) and mapping partners (address metadata) and add it to your account.",
            },
            {
                label: "2. Use of Information",
                desc: "We use your information to:\n- Provide and improve our services, including routing missions, matching Glitters with nearby requests and generating inspection reports\n- Verify your identity, satisfy payment/KYC obligations imposed by Stripe, and process payouts\n- Determine availability, geolocate services, and send reminders or safety notices via email or push notifications\n- Cache report drafts locally so you can work offline and then synchronize them securely\n- Maintain security, investigate fraud or abuse, and comply with legal and regulatory obligations\n- Contact you for updates, offers, retention reminders and support",
            },
            {
                label: "3. Sharing of Information",
                desc: "We do not sell your personal data. However, we may share strictly necessary information with:\n- Stripe (payments, identity verification, payouts) which processes your identity documents and bank data on our behalf\n- Amazon Web Services and our hosting partners (application hosting and S3 storage for photos, ID documents and reports)\n- Communication providers such as our SMTP relay, Expo, Apple Push Notification service and Firebase Cloud Messaging to deliver transactional emails and push alerts\n- Mapping and geocoding partners (Google Places/Maps) when you look up or confirm an address inside the apps\n- Analytics, logging and security tooling that run inside our Strapi infrastructure to detect abuse and ensure platform safety\n- Legal authorities if required by law or to prevent fraud\n- Third parties in case of a merger or acquisition, in which case you will be notified beforehand",
            },
            {
                label: "4. Data Retention",
                desc: "We retain your data as long as necessary to provide our services and meet legal obligations.",
            },
            {
                label: "4.1. Inactive Account",
                desc: "An account is considered inactive after 12 consecutive months without any login or activity. We automatically send an email reminder 14 days before deletion; logging back in cancels the scheduled deletion. If you remain inactive, the account and its associated profiles are deleted together with the remaining data, except for information we must keep for legal obligations.",
            },
            {
                label: "4.2. Incomplete Registration",
                desc: "If registration is not completed within an hour of starting the process, the collected information, as well as the account, will be deleted.",
            },
            {
                label: "4.3. Automatic Report Deletion",
                desc: "Inspection reports, photos and attachments are stored for 90 days after the report is marked completed so customers can download them. Once the retention window expires—or immediately when you delete the related request/account—our automated job removes the report from the database and deletes every associated file from AWS S3.",
            },
            {
                label: "5. Data Security",
                desc: "We implement advanced security measures to protect your information against unauthorized access, loss, or alteration.",
            },
            {
                label: "6. Your Rights",
                desc: "In accordance with the GDPR and other applicable laws, you have the following rights:\n- Access: Obtain a copy of your data\n- Rectification: Correct your information\n- Deletion: Request account deletion\n- Objection: Refuse certain uses of your data\n- Portability: Retrieve your data in a usable format\n\nTo exercise your rights, contact us at support@glitgo.com.",
            },
            {
                label: "7. Cookies and Similar Technologies",
                desc: "We use strictly necessary cookies and local storage to keep the website functional (for example, to remember the language you selected). These technologies are never used for advertising or cross-site tracking.",
            },
            {
                label: "7.1. Functional cookie details",
                desc: "- Cookie name: i18next\n- Purpose: Stores the last language you selected so that pages automatically load in the same language on your next visit\n- Storage duration: 12 months (the cookie is renewed whenever you revisit the site)\n- Provider: GlitGo website via i18next-browser-languagedetector\n\nYou can delete or block this cookie from your browser settings at any time. If you do so, the site will revert to English on every visit and may ask for your preferred language again.",
            },
            {
                label: "8. Changes to the Privacy Policy",
                desc: "We may update this privacy policy at any time. The last update date is displayed at the top of this document.",
            },
            {
                label: "9. Contact",
                desc: "For any questions regarding our privacy policy, contact us at the following address:\nsupport@glitgo.com\nGlitGo — 4 Passage des Ballades, 95800 Cergy, France",
            },
        ],
    },

    deleteAccount: {
        header: "Delete Account",
        description:
            "We're sorry to see you go. Please select your profile type and follow the guide below to delete your account.",
        profileTypes: {
            title: "Select Your Profile Type",
            glitter: {
                title: "Glitter Profile (GlitGo Pro)",
                description: "Professional service provider account",
                icon: "🧹",
            },
            customer: {
                title: "Customer Profile (GlitGo)",
                description: "Service request account",
                icon: "🚗",
            },
        },
        deletionGuide: {
            title: "How to Delete Your Account",
            step1: {
                title: "Open the App",
                description: "Launch the GlitGo app on your device",
                path: "Settings → Profile → Delete Account",
            },
            step2: {
                title: "Confirm Deletion",
                description:
                    "Read the warning message and confirm your decision",
            },
            step3: {
                title: "Complete Process",
                description:
                    "Follow the on-screen instructions to complete the account deletion",
            },
            alternative: {
                title: "Alternative Method",
                description:
                    "If you cannot access the app, you can request account deletion by email",
                email: "Send email to:",
            },
        },
        warning:
            "⚠️ Warning: Account deletion is permanent and cannot be undone. All your data, including service history and personal information, will be permanently removed.",
        contactEmail: "support@glitgo.com",
        contact: {
            label: "Email",
        },
        footer: "If you have any questions or need assistance, please don't hesitate to contact our support team.",
    },
};

export default translations;
